<template>
  <div class="min-vh-100 w-100 d-flex align-items-center justify-content-center">
    <div class="w-100 text-center p-2">
      <FormLogin
        :loading="loading" :email-senha-incorreta="emailSenhaIncorreta"
        :class="{ 'animate__animated animate__shakeX': shake }" @animationend="endShake"
        @authenticate="onAuthenticate"
      />
      <Background />
    </div>
  </div>
</template>

<script>
import FormLogin from './components/FormLogin.vue';
import Background from './components/BackgroundLogin.vue';
import { login } from './service';
import { useToast } from 'vue-toastification';
import { getTipoUsuario } from '@/modules/shared/storage';
import { i18n } from '../localization';

export default {
  components: { FormLogin, Background },
  data: () => ({ loading: false, shake: false, emailSenhaIncorreta: false }),
  methods: {
    async onAuthenticate(credential) {
      this.loading = true;
      this.emailSenhaIncorreta = false;
      try {
        if (await login(credential)) {
          const tipoUsuario = getTipoUsuario();
          const config = this.$router.rotasUsuarios?.[tipoUsuario];

          if (config) {
            config.routes.forEach((route) => this.$router.addRoute(route));
            this.$router.addRoute({
              path: '/:catchAll(.*)',
              name: 'catchAll',
              redirect: config.redirect,
            });
            this.$router.push(config.redirect);
          } else {
            this.$router.push('/');
          }
        } else {
          this.emailSenhaIncorreta = true;
          this.startShake();
        }
      } catch (error) {
        useToast().error(i18n.global.t('erroDeConexao'));
      } finally {
        this.loading = false;
      }
    },
    startShake() { this.shake = true; },
    endShake() { this.shake = false; },
  },
};
</script>
